export const filterConstants = {
  CLEANALL: 'CLEAN_ALL',
  CLEANRESEND: 'CLEAN_RESEND',
  CLEANHISTORY: 'CLEAN_HISTORY',
  CLEANSTATES: 'CLEAN_STATES',
  CLEANREASSIGN: 'CLEAN_REASSIGN',
  SETRESEND: 'SET_RESEND',
  SETHISTORY: 'SET_HISTORY',
  SETSTATES: 'SET_STATES',
  SETREASSIGN: 'SET_REASSIGN',
}
